/* global System */
import withLazyUnveil from '../../higher-order-components/withLazyUnveil'

export default {
  Accordion: withLazyUnveil({
    loadComponent: () =>
      System.import(
        /* webpackChunkName: "Accordion" */
        './index'
      ),
    height: 300,
    mobileHeight: 300,
  }),
}
